import gql from "graphql-tag";

export const UpdateAccountPreference = gql`
  mutation UpdateAccountPreference($preference: UpdateAccountPreferenceInput!) {
    updateAccountPreference(preference: $preference)
  }
`;
